module.exports = __webpack_public_path__ + "img/tg.cdc037b7.svg";